import React from 'react';
import { mainGuide } from '../data/resources';
import { guideInteriorPages } from '../data/pendingContent';
import { siteConfig } from '../data/siteConfig';
const topics = [{
  title: 'Scegliere e preparare il supporto',
  text: 'Riconoscere un supporto trasparente adatto, pulirlo e prepararlo prima di iniziare.'
}, {
  title: 'Posizionare il modello',
  text: 'Sistemare il modello sotto il supporto e fissarlo perché non si sposti mentre tracci.'
}, {
  title: 'Tracciare i contorni',
  text: 'Impugnare il tubetto del contorno, dosare la pressione e chiudere ogni area per accogliere il colore.'
}, {
  title: 'Applicare i colori',
  text: 'Stendere e distribuire il colore, poi rispettare l’asciugatura indicata per i prodotti che usi.'
}, {
  title: 'Riconoscere gli errori più comuni',
  text: 'Capire perché il colore sborda o un contorno si interrompe, e sapere come evitarlo la volta successiva.'
}];
export function MainGuide() {
  return <section aria-labelledby="guide-title" className="bg-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-129" data-mp="h4vh0zdpzz4a">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-start" data-id="element-130" data-mp="3pyv6f7wuv4rt">
        <div className="lg:col-span-5 lg:sticky lg:top-24" data-id="element-131" data-mp="3lyjklrsrayer">
          <div className="rounded-[2rem] bg-sand overflow-hidden aspect-square shadow-soft" data-id="element-132" data-mp="3tzt5bleqomk">
            <img src={mainGuide.image} alt={mainGuide.imageAlt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-133" data-mp="3uz9gswlxiqt0" />
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-134" data-mp="377u90obdvhad">
          <p className="text-sm font-semibold text-coral-deep" data-id="element-135" data-mp="32bveeizgp31i">La guida principale</p>
          <h2 id="guide-title" className="mt-2 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal" data-id="element-136" data-mp="3h0i49emptd6z">
            La guida che ti accompagna dall’inizio
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-ink/80 max-w-xl" data-id="element-137" data-mp="2ojfj64csy9b5">
            <span className="font-semibold text-ink" data-id="element-138" data-mp="2jkm4i8ls4c9e">{siteConfig.brandName}</span>{' '}
            ti accompagna dalla preparazione del supporto alle rifiniture:
            tracciare contorni regolari, applicare il colore, rispettare i tempi
            di asciugatura dei tuoi prodotti ed evitare gli errori più frequenti.
          </p>

          <ol className="mt-10 border-t border-ink/10" data-id="element-139" data-mp="x8bzpyftuxlc">
            {topics.map((t, i) => <li key={t.title} className="grid grid-cols-[2.5rem_1fr] gap-x-3 py-5 border-b border-ink/10" data-id="element-140" data-mp="119e2uqcv7tsl" data-mpi={i}>
                <span className="font-serif text-xl font-semibold text-coral-deep leading-snug" data-id="element-141" data-mp="4jdh707sltfi">
                  {i + 1}
                </span>
                <div data-id="element-142" data-mp="9jss7l4lqoub">
                  <h3 className="font-serif text-lg sm:text-xl font-semibold text-teal" data-id="element-143" data-mp="dja0embey036">
                    {t.title}
                  </h3>
                  <p className="mt-1 text-base leading-relaxed text-ink/75" data-id="element-144" data-mp="ijfsg3llhols">{t.text}</p>
                </div>
              </li>)}
          </ol>

          {guideInteriorPages.length > 0 && <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-145" data-mp="1tx0feo42m8rl">
              {guideInteriorPages.map(page => <div key={page.src} className="aspect-[3/4] rounded-xl overflow-hidden bg-sand shadow-soft" data-id="element-146" data-mp="241q9y8x5aals">
                  <img src={page.src} alt={page.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-147" data-mp="1z3f0hzari243" />
                </div>)}
            </div>}
        </div>
      </div>
    </section>;
}